import './bouncingWords.css'
import React from 'react'
import BouncingWord from '../bouncingWord/bouncingWord'
import randomWords from 'random-words'

 const BouncingWords = ({numWords, maxLength, fullscreen, randomColour}) => {

    let root = document.documentElement;

    if (fullscreen) {
        root.style.setProperty('--bouncing-height', '100vh');
    }

    let words = randomWords({exactly: numWords, maxLength: maxLength})

    return (
        <div className={"blob-wrap"}>
            {words.map(
                (word) => <BouncingWord text={word} randomColour={randomColour} />
            )}
        </div>
    )
}

export default BouncingWords